import { useMutation, Types } from "@grandvisionhq/graphql";
import { SIGNUP_PROMOTION } from "../../operations/mutations/operations/mutations/signup-promotion.js";
const mapConsents = (selectedConsents) => selectedConsents.map((consent) => ({
  consentName: consent.title,
  literalText: consent.title,
  uiType: Types.UIType.CHECKBOX,
  value: true
  // function only gets selectedConsents
}));
const mapOptIns = (optIns) => optIns.map((optIn) => ({
  id: optIn.value,
  value: true,
  literalText: optIn.title,
  uiType: Types.UIType.CHECKBOX
}));
const useSignupCampaign = () => {
  const [signupCampaignMutation, { data, loading }] = useMutation(SIGNUP_PROMOTION);
  const callback = ({ consents, optIns, personalDetails, ...rest }) => signupCampaignMutation({
    variables: {
      signupPromotionInput: {
        consents: mapConsents(consents),
        optIns: mapOptIns(optIns),
        personalDetails: {
          firstName: personalDetails.firstName,
          middleName: personalDetails.middleName,
          lastName: personalDetails.lastName,
          email: personalDetails.email
        },
        ...rest
      }
    }
  });
  return [
    callback,
    {
      campaignId: data?.signupPromotion?.success ? data?.signupPromotion?.campaignId : "",
      isLoading: loading,
      error: data?.signupPromotion?.errorMessage || null,
      success: !!data?.signupPromotion?.success
    }
  ];
};
export {
  useSignupCampaign
};
//# sourceMappingURL=use-signup-campaign.js.map
